import { Dialog, DialogContent, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PersonDetailView from './PersonDetailView';
import { useCloseOnBack } from '../../hooks/useCloseOnBack';

/**
 * Modal de detalhe da Person (full-screen no mobile). Usado para abrir o detalhe a partir
 * de outros contextos (agendamentos, financeiro) e voltar fechando.
 */
export default function PersonDetailDialog({ open, personId, onClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  // Voltar do celular fecha a janela (tela cheia) em vez de sair da tela — utils/backButtonLayers.js.
  useCloseOnBack(open && fullScreen, onClose);

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} maxWidth="lg" fullWidth scroll="paper">
      <DialogContent sx={{ p: { xs: 1.5, sm: 2 } }}>
        {open && personId && <PersonDetailView personId={personId} onClose={onClose} />}
      </DialogContent>
    </Dialog>
  );
}
